<template>
  <div class="container-fluid">
    <b-row>
      <b-col class="pr-0">
        <h2>Vos notifications</h2>
      </b-col>
    </b-row>

    <!-- Navigation tabs like NavBar -->
    <b-row style="overflow-x: auto;" class="mt-3">
      <b-col>
        <nav class="ob1-menu-page h-100">
          <ul class="nav o-nav-light">
            <li class="nav-item" :class="activeTab === 0 ? 'active' : ''">
              <span class="nav-link cursor-pointer" @click="activeTab = 0">
                Alertes
                <span
                  v-if="totalAlerts > 0"
                  class="notification icon-orange-info"
                >
                  <span class="badge">{{ totalAlerts }}</span>
                </span>
              </span>
            </li>
            <li class="nav-item" :class="activeTab === 1 ? 'active' : ''">
              <span class="nav-link cursor-pointer" @click="activeTab = 1">
                Notifications de sécurité
                <span v-if="storeUnreadNotificationsCount > 0" class="notification">
                  <i class="fa fa-bell"></i>
                  <span class="badge">{{ storeUnreadNotificationsCount }}</span>
                </span>
              </span>
            </li>
            <li class="nav-item" :class="activeTab === 2 ? 'active' : ''">
              <span class="nav-link cursor-pointer" @click="activeTab = 2">
                Communication produit
                <span v-if="storeUnreadProductCommunicationsCount > 0" class="notification">
                  <i class="fa fa-bell"></i>
                  <span class="badge">{{ storeUnreadProductCommunicationsCount }}</span>
                </span>
              </span>
            </li>
          </ul>
        </nav>
      </b-col>
    </b-row>

    <!-- Security Alerts content -->
    <div v-show="activeTab === 0" class="mt-4">
      <div v-if="!isLoadingAlerts">
        <b-row v-if="alerts.length > 0">
          <b-col>
            <ul class="items-list row d-flex flex-wrap">
              <li v-for="alert in alerts" :key="alert.id" class="col-12">
                <div
                  class="items-list-item max-width"
                  style="max-width: none!important;"
                >
                  <div class="item-container">
                    <div class="w-100">
                      <b-row class="my-2" align-h="between">
                        <b-col class="d-flex align-items-center">
                          <span
                            v-if="alert.severity === 'Low'"
                            class="ob1-capsule ob1-capsule-disabled mb-1 text-center mr-1 ml-0"
                            >Risque faible</span
                          >
                          <span
                            v-else-if="alert.severity === 'Medium'"
                            class="ob1-capsule ob1-capsule-inverse bg-warning mb-1 text-center mr-1 ml-0"
                            >Risque moyen</span
                          >
                          <span
                            v-else-if="alert.severity === 'High'"
                            class="ob1-capsule ob1-capsule-inverse bg-danger mb-1 text-center mr-1 ml-0"
                            >Risque fort</span
                          >
                          <span
                            v-else-if="alert.severity === 'Critical'"
                            class="ob1-capsule ob1-capsule-inverse bg-danger mb-1 text-center mr-1 ml-0"
                            >Risque critique</span
                          >
                        </b-col>
                        <b-col class="text-right col-auto">
                          <small
                            >Ajouté le
                            {{
                              moment(alert.reported_at).format(
                                "DD/MM/YYYY hh:mm:ss"
                              )
                            }}</small
                          >
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <b>{{ alert.agent ? alert.agent.computer_name : 'Poste inconnu' }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          Cyber Sécurité a bloqué un fichier potentiellement
                          malveillant dans votre système :
                          <b>{{ alert.filename }}</b
                          >.
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          Si le fichier est considéré comme étant malveillant
                          par Cyber Protection, il a été mis en quarantaine.
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>

        <b-row v-if="totalItems > 20" class="mt-4">
          <b-col></b-col>
          <b-col>
            <b-form inline>
              <label class="mr-2">Elements par page : </label>
              <b-form-select
                v-model="perPage"
                :options="perPageOptions"
              ></b-form-select>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
              <label class="ml-4">Total : {{ totalItems }}</label>
            </b-form>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <p>
              Aucune alerte détectée
              {{
                this.paramRequest.agentId ? "sur le poste sélectionné" : ""
              }}
              ces 30 derniers jours
            </p>
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-center" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <!-- Notifications content -->
    <div v-show="activeTab === 1" class="mt-4">
      <div v-if="!isLoadingNotifications">
        <b-row v-if="storeNotifications.length > 0">
          <b-col>
            <ul class="items-list row d-flex flex-wrap">
              <li
                v-for="notification in storeNotifications"
                :key="notification.id"
                class="col-12"
              >
                <div
                  class="items-list-item max-width"
                  style="max-width: none!important;"
                >
                  <div class="item-container">
                    <div class="w-100">
                      <b-row class="my-2" align-h="between">
                        <b-col class="d-flex align-items-center">
                          <span
                            v-if="!notification.is_read"
                            class="ob1-capsule ob1-capsule-inverse mr-1 ml-0"
                            style="background-color: #ff7900;"
                            >Nouveau</span
                          >
                          <span
                            v-else
                            class="ob1-capsule ob1-capsule-disabled mr-1 ml-0"
                            >Lu</span
                          >
                        </b-col>
                        <b-col class="text-right col-auto">
                          <small
                            >Reçu le
                            {{
                              moment(notification.sent_at).format(
                                "DD/MM/YYYY HH:mm:ss"
                              )
                            }}</small
                          >
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <b>{{ notification.object }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <div
                            v-html="notification.body"
                            class="notification-body"
                          ></div>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <span
                            v-if="!notification.is_read"
                            class="o-link-arrow ob1-link"
                            @click="markAsRead(notification.id)"
                            style="cursor:pointer;"
                          >
                            <u>Marquer comme lu</u>
                          </span>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>

        <b-row v-if="totalNotifications > 20" class="mt-4">
          <b-col></b-col>
          <b-col>
            <b-form inline>
              <label class="mr-2">Elements par page : </label>
              <b-form-select
                v-model="notifPerPage"
                :options="perPageOptions"
              ></b-form-select>
              <b-pagination
                v-model="notifCurrentPage"
                :total-rows="totalNotifications"
                :per-page="notifPerPage"
              ></b-pagination>
              <label class="ml-4">Total : {{ totalNotifications }}</label>
            </b-form>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <p class="text-center mt-4">
              Aucune notification reçue ces 30 derniers jours
            </p>
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-center" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <!-- Product Communications content -->
    <div v-show="activeTab === 2" class="mt-4">
      <div v-if="!isLoadingProductCommunications">
        <b-row v-if="storeProductCommunications.length > 0">
          <b-col>
            <ul class="items-list row d-flex flex-wrap">
              <li
                v-for="communication in storeProductCommunications"
                :key="communication.id"
                class="col-12"
              >
                <div
                  class="items-list-item max-width"
                  style="max-width: none!important;"
                >
                  <div class="item-container">
                    <div class="w-100">
                      <b-row class="my-2" align-h="between">
                        <b-col class="d-flex align-items-center">
                          <span
                            v-if="!communication.is_read"
                            class="ob1-capsule ob1-capsule-inverse mr-1 ml-0"
                            style="background-color: #ff7900;"
                            >Nouveau</span
                          >
                          <span
                            v-else
                            class="ob1-capsule ob1-capsule-disabled mr-1 ml-0"
                            >Lu</span
                          >
                        </b-col>
                        <b-col class="text-right col-auto">
                          <small
                            >Reçu le
                            {{
                              moment(communication.sent_at).format(
                                "DD/MM/YYYY HH:mm:ss"
                              )
                            }}</small
                          >
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <b>{{ communication.object }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <div
                            v-html="communication.body"
                            class="notification-body"
                          ></div>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col>
                          <span
                            v-if="!communication.is_read"
                            class="o-link-arrow ob1-link"
                            @click="markProductCommunicationAsRead(communication.id)"
                            style="cursor:pointer;"
                          >
                            <u>Marquer comme lu</u>
                          </span>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>

        <b-row v-if="totalProductCommunications > 20" class="mt-4">
          <b-col></b-col>
          <b-col>
            <b-form inline>
              <label class="mr-2">Elements par page : </label>
              <b-form-select
                v-model="productCommPerPage"
                :options="perPageOptions"
              ></b-form-select>
              <b-pagination
                v-model="productCommCurrentPage"
                :total-rows="totalProductCommunications"
                :per-page="productCommPerPage"
              ></b-pagination>
              <label class="ml-4">Total : {{ totalProductCommunications }}</label>
            </b-form>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <p class="text-center mt-4">
              Aucune communication produit reçue ces 30 derniers jours
            </p>
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-center" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import moment from "moment";
import logger from "@/utils/func/logger";

export default {
  name: "Alerte",
  components: { Loader },

  data() {
    return {
      moment: moment,
      activeTab: 0,
      // Security alerts data
      alerts: [],
      isLoadingAlerts: true,
      totalAlerts: 0,
      paramRequest: {
        page: 1,
        perPage: 100,
      },
      currentPage: 1,
      perPage: 100,
      totalItems: 0,
      page: 1,
      perPageOptions: [10, 15, 25, 50, 100],

      // Notifications data
      isLoadingNotifications: true,
      totalNotifications: 0,
      notifCurrentPage: 1,
      notifPerPage: 20,

      // Product Communications data
      isLoadingProductCommunications: true,
      totalProductCommunications: 0,
      productCommCurrentPage: 1,
      productCommPerPage: 20,


    };
  },
  computed: {
    adminOhpEuid() {
      return this.$store.state.configuration.adminOhpEuid || "";
    },
    //@get notifications from Vuex store
    storeNotifications() {
      return this.$store.getters['notification/getNotifications'] || [];
    },
    storeUnreadNotificationsCount() {
      return this.$store.getters['notification/getUnreadCount'] || 0;
    },
    //@get product communications from Vuex store
    storeProductCommunications() {
      return this.$store.getters['notification/getProductCommunications'] || [];
    },
    storeUnreadProductCommunicationsCount() {
      return this.$store.getters['notification/getUnreadProductCommunicationsCount'] || 0;
    },
  },
  mounted() {
    this.$store.commit(
      "configuration/updateAdminOhpEuid",
      this.$route.query.ohpEuid
    );
    this.paramRequest.agentId = this.$route.query.agentId;
    this.getAlerts();
    this.getNotifications();
    this.getProductCommunications();
    
    //@setup real-time notification listeners
    this.setupRealtimeListeners();
  },
  beforeDestroy() {
    //@cleanup real-time listeners
    this.cleanupRealtimeListeners();
  },
  methods: {
    getAlerts() {
      this.isLoadingAlerts = true;

      // Configure Request parameter
      this.paramRequest.page = this.currentPage;
      this.paramRequest.perPage = this.perPage;
      this.paramRequest.adminOhpEuid = this.adminOhpEuid;

      this.$store
        .dispatch("alert/getAlerts", this.paramRequest)
        .then((res) => {
          logger.log("SUCCESS getAlerts", res);
          this.alerts = res.data;
          this.totalItems = res.total;
          this.totalAlerts = res.total;
          this.isLoadingAlerts = false;
        })
        .catch((err) => {
          logger.error("Err call getAlerts", err);
          this.isLoadingAlerts = false;
        });
    },

    getNotifications() {
      this.isLoadingNotifications = true;

      const params = {
        page: this.notifCurrentPage,
        perPage: this.notifPerPage,
      };

      this.$store
        .dispatch("notification/getNotifications", params)
        .then((res) => {
          logger.log("SUCCESS getNotifications", res);
          //@data is now stored in Vuex store, no need for local state
          this.totalNotifications = res.total;
          this.isLoadingNotifications = false;
        })
        .catch((err) => {
          logger.error("Error getting notifications", err);
          this.isLoadingNotifications = false;
        });
    },

    markAsRead(notificationId) {
      this.$store
        .dispatch("notification/markAsRead", notificationId)
        .then(() => {
          //@state is now updated in Vuex store, no need for local state manipulation
        })
        .catch((err) => {
          logger.error("Error marking notification as read", err);
        });
    },

    getProductCommunications() {
      this.isLoadingProductCommunications = true;

      const params = {
        page: this.productCommCurrentPage,
        perPage: this.productCommPerPage,
        type: 'product_communication'
      };

      this.$store
        .dispatch("notification/getProductCommunications", params)
        .then((res) => {
          logger.log("SUCCESS getProductCommunications", res);
          //@data is now stored in Vuex store, no need for local state
          this.totalProductCommunications = res.total;
          this.isLoadingProductCommunications = false;
        })
        .catch((err) => {
          logger.error("Error getting product communications", err);
          this.isLoadingProductCommunications = false;
        });
    },

    markProductCommunicationAsRead(communicationId) {
      this.$store
        .dispatch("notification/markProductCommunicationAsRead", communicationId)
        .then(() => {
          //@state is now updated in Vuex store, no need for local state manipulation
        })
        .catch((err) => {
          logger.error("Error marking product communication as read", err);
        });
    },

    setupRealtimeListeners() {
      const userId = localStorage.getItem('user.id');

      if (!userId) {
        return;
      }

      //@listen for security notifications
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.security-notification.created', (data) => {
          //@refresh notifications to show new one
          this.getNotifications();
        });

      //@listen for product communications
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.product-communication.created', (data) => {
          //@refresh product communications to show new one
          this.getProductCommunications();
        });

      //@listen for alerts
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.alert.created', () => {
          //@refresh alerts to show new one
          this.getAlerts();
        });
    },

    cleanupRealtimeListeners() {
      const userId = localStorage.getItem('user.id');
      
      if (userId) {
        this.$echo.leave(`notifications.user.${userId}`);
      }
      
      //@cleanup tenant channel if exists
      const tenantId = localStorage.getItem('tenant.id');
      if (tenantId) {
        this.$echo.leave(`notifications.tenant.${tenantId}`);
      }
    },


  },
  watch: {
    currentPage: {
      handler: function() {
        this.getAlerts();
      },
    },
    perPage: {
      handler: function() {
        this.getAlerts();
      },
    },
    notifCurrentPage: {
      handler: function() {
        this.getNotifications();
      },
    },
    notifPerPage: {
      handler: function() {
        this.getNotifications();
      },
    },
    productCommCurrentPage: {
      handler: function() {
        this.getProductCommunications();
      },
    },
    productCommPerPage: {
      handler: function() {
        this.getProductCommunications();
      },
    },
    paramRequest: {
      handler: function(param) {
        logger.log("change event ", param);
        this.$router
          .replace({
            name: "Alert",
            query: {
              perPage: param.perPage,
              page: param.page,
              agentId: param.agentId,
            },
          })
          .catch(() => {});
        // Update pagination
        this.perPage = param.perPage;
        this.page = param.page;
        this.getAlerts();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.notification {
  position: relative;
  display: inline-block;
  margin-left: 10px;
}

.notification .fa-bell {
  color: black;
}

.notification .badge {
  position: absolute;
  top: -8px;
  right: -8px;
  padding: 3px 6px;
  border-radius: 50%;
  background: red;
  color: white;
  font-size: 11px;
  min-width: 18px;
  text-align: center;
}

.cursor-pointer {
  cursor: pointer;
}

.notification-body {
  color: #333;
  line-height: 1.6;
}

.notification-body /deep/ p {
  margin-bottom: 0.5rem;
}

.notification-body /deep/ p:last-child {
  margin-bottom: 0;
}
</style>
